import { forwardRef, createContext, useContext } from 'react';
import { logDsxWarning } from '../util/logging.js';
import { jsx } from 'react/jsx-runtime';

const LinkSourceContext = /*#__PURE__*/createContext({});
const defaultLink = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/jsx("a", {
  ref: ref,
  ...props
}));
defaultLink.displayName = 'defaultLink';
const noneLink = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/jsx("span", {
  ref: ref,
  ...props
}));
noneLink.displayName = 'noneLink';
const defaultLinkSources = {
  default: defaultLink,
  none: noneLink
};
function LinkSourceProvider(props) {
  const {
    linkSources = defaultLinkSources,
    children
  } = props;
  return /*#__PURE__*/jsx(LinkSourceContext.Provider, {
    value: linkSources,
    children: children
  });
}
function useLinkSource(props) {
  const {
    href,
    hrefType,
    target,
    rel,
    ...rest
  } = props;
  const record = useContext(LinkSourceContext);
  let Link = hrefType === 'UNSAFE_default' ? defaultLink : hrefType === 'UNSAFE_none' ? noneLink : record[hrefType || 'default'];
  if (!Link) {
    logDsxWarning('LinkProvider', `tried to get the link source "${hrefType}", but it was not found. Is this source listed in the top-level Provider.linkSources of your application? Falling back to "default".`);
    Link = record['default'];
  }
  return {
    Link,
    linkProps: {
      href,
      target,
      rel
    },
    rest
  };
}

export { LinkSourceProvider, useLinkSource };
